<template>
  <div>
    <headNavBar title="关于我们" :fixed="true" />
    <div class="mt-header-nav">
      <div class="logo-img">
        <img
          :src="
            versionConfig.ZHIYUN_VERSION
              ? `/image/${appConfig.logo ? appConfig.logo : 'zy_logo.png'}`
              : '/image/hy_logo.png'
          "
        />
      </div>
      <p class="intro">
        更专业的住宿管理系统——{{
          versionConfig.ZHIYUN_VERSION
            ? appConfig.title
              ? appConfig.title
              : "智云Plus"
            : "鸿云PMS"
        }}，适用于民宿、客栈、酒店，为每一位客户提供领先的住宿信息化一体解决方案。
      </p>
      <p class="intro">
        公司专注酒店管理软件16年，坚守技术立命初心，持续为数千家民宿及酒店提供服务，行业积累深，用户更认可，实力更靠谱。
      </p>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      versionConfig,
    };
  },
  computed: {
    ...mapState({
      appConfig: state => state.app.appConfig,
    }),
  },
};
</script>

<style lang="less">
.logo-img {
  text-align: center;
  margin-top: 40px;
  img {
    height: 120px;
    display: block;
    margin: 0 auto 20px;
  }
}
.intro {
  padding: 0.2rem 0.5rem 0 0.5rem;
  font-size: 14px;
  line-height: 26px;
  text-align: left;
  text-indent: 1rem;
}
</style>
